import { buildCdnRenderPath, type CdnRenderOptions } from "./buildCdnRenderPath";

export function buildCdnSrcSet(
  path: string,
  widths: readonly number[],
  options: Omit<CdnRenderOptions, "width"> = {},
): string {
  return widths
    .map((width) => `${buildCdnRenderPath(path, { ...options, width })} ${width}w`)
    .join(", ");
}
